import MultiSelectInput from '@repo/ui/multiselect-input'
import { useQuery } from '@tanstack/react-query'

import NumberInput from '../../../../../../../packages/ui/components/atoms/input/number-input'
import { getCountries } from '../../../../api/countries/get-countries'
import { getFormulas } from '../../../../api/formula/get-formulas'
import { getPeriods } from '../../../../api/periods/get-periods'
import { OptionFilters } from '../../../../lib/types/models/options/option'
import { getTranslatedName } from '../../../../lib/utils/functions/translation.functions'

type Props = {
  filter?: OptionFilters
  onFilterChange: (filter: OptionFilters) => void
}

const JourneyPlaceOptionFilter = ({ filter, onFilterChange }: Props) => {
  const { data } = useQuery({
    queryKey: ['countries'],
    queryFn: () => getCountries()
  })

  const { data: formulas } = useQuery({
    queryKey: ['formulas'],
    queryFn: () => getFormulas()
  })

  const { data: periods } = useQuery({
    queryKey: ['periods'],
    queryFn: () => getPeriods({ version: 'BASIC' })
  })

  function setFilter<K extends keyof OptionFilters>(key: K, value: OptionFilters[K]) {
    onFilterChange({ ...filter, [key]: value })
  }
  return (
    <div className="mt-5 flex flex-col gap-4">
      <MultiSelectInput
        searchable
        label={'Pays'}
        variant={'primary'}
        options={data?.data?.map((country) => ({ label: country.name, value: +country.id }))}
        onChange={(countries) => setFilter('countries', countries)}
        selectedOptions={filter?.countries?.map((country) => ({
          label: data?.data?.find((c) => c.id === country)?.name || '',
          value: country
        }))}
      />
      <MultiSelectInput
        label={'Formule de séjour'}
        variant={'primary'}
        searchable
        options={formulas?.data?.map((formula) => ({
          label: getTranslatedName(formula),
          value: formula.id
        }))}
        onChange={(formulas) => setFilter('formulas', formulas)}
        selectedOptions={filter?.formulas?.map((formula) => ({
          label: getTranslatedName(formulas?.data?.find((f) => f.id === formula)),
          value: formula
        }))}
      />
      <MultiSelectInput
        label={'Période de séjour'}
        variant={'primary'}
        searchable
        options={periods?.data?.map((period) => ({ label: period.name, value: period.id }))}
        onChange={(periods) => setFilter('periods', periods)}
        selectedOptions={filter?.periods?.map((period) => ({
          label: periods?.data?.find((p) => p.id === period)?.name || '',
          value: period
        }))}
      />
      <NumberInput
        label={'Durée en jours'}
        value={filter?.durationInDays}
        onChange={(e) => setFilter('durationInDays', parseInt(e.target.value))}
      />
    </div>
  )
}

export default JourneyPlaceOptionFilter
